export enum SortOrder {
  Ascending = 'ASCENDING',
  Descending = 'DESCENDING',
}
